:host {
}

.stzh-eventdata {
  display: flex;
  flex-direction: column;
  row-gap: space("xsmall");
  column-gap: space("medium");

  &__label {
    @include font("heavy");
    @include fontCurve("p1");
    flex-shrink: 0;

    @include mq($from: small) {
      min-width: 160px;
    }

    @include mq($from: medium) {
      min-width: 174px;
    }

    @include mq($from: large) {
      min-width: 182px;
    }
  }

  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    row-gap: space("xsmall");
  }
}
